import { AccessProtectedPage } from './AccessProtectedPage';
import { ProductType } from 'types';
import MoviefoneContainer from 'components/moviefone/MoviefoneContainer';
import { useCallback } from 'react';

export const MoviefonePage = () => {
  return (
    <AccessProtectedPage
      productType={ProductType.MOVIEFONE}
      renderContent={useCallback(
        () => (
          <MoviefoneContainer />
        ),
        [],
      )}
    />
  );
};
